import React, { useState } from 'react';
import { FormGroup, InputGroup, Button, Form, Glyphicon } from 'react-bootstrap';
import PropTypes from 'prop-types';

const Search = ({ query, disabled, onChange }) => {
  const [currentQuery, setCurrentQuery] = useState(query || '');

  const onSubmit = (e) => {
    e.preventDefault();
    onChange(currentQuery);
  }

  return (
    <div className="">
      <Form onSubmit={onSubmit}>
        <FormGroup className="mb-0">
          <InputGroup>
            <div className="form-control__with-clear">
              <input
                className="form-control"
                type="text"
                disabled={disabled}
                placeholder="Search..."
                value={currentQuery}
                onChange={(e) => setCurrentQuery(e.currentTarget.value)}
              />
              {query ? (
                <button type="button" onClick={() => setCurrentQuery('')} className="clear">
                  <span className="fas fa-times" />
                </button>
              ) : null}
            </div>
            <InputGroup.Button>
              <Button className="custom__search-button" onClick={onSubmit} disabled={disabled}>
                <Glyphicon glyph="search" />
              </Button>
            </InputGroup.Button>
          </InputGroup>
        </FormGroup>
      </Form>
    </div>
  );
}

Search.propTypes = {
  query: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
};

export default Search;
